import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import MEliminarEmpaquetadorEtapaPT from "@Productos/Modales/MEliminarEmpaquetadorEtapaPT";
import MAgregarEditarProductoTerminado from "@Productos/Modales/MAgregarEditarProductoTerminado";
import MAgregarEditarEmpaquetadorEtapaPT from "@Productos/Modales/MAgregarEditarEmpaquetadorEtapaPT";

import MEliminarPT from "@ProductosProduccion/ModalesDetalleInferior/MEliminarPT";

import * as _testing_ from "@Funciones/testing";
import "./MDetalleInferiorEtapasPT.css";

function MDetalleInferiorEtapasPT({
  origenComponente,
  registro = {},
  parametros,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
}) {
  const { ecv_u, cv_u } = useContext(Contexto);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],

    //ADICIONALES
    agregarEtapaModal: false,
    relacionarPT_mostrar: false,
  });
  const [v_u, ev_u] = useState({
    procesandoAPI: false,
    exitoAPI: false,
    do_datosTabla: {},
    da_gridMaestro: [],
    da_headgridMaestro: [],
    da_gridProductoTerminado: [],
    da_headgridProductoTerminado: [],
  });

  const [recargaMaestros, erecargaMaestros] = useState(false);
  const [recargaPP, erecargaPP] = useState(false);

  useEffect(() => {
    console.log(origenComponente, registro, parametros, tipoEvento);

    const maestroProductoAPI = _api_.f_RelacionEmpaquetadoraEtapaPT({
      parametros: { modo: "DSG", codEmpaquetador: "", codEtapa: registro?.codigo },
      timeout: 5000,
      origen: origenComponente,
    });
    maestroProductoAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          da_gridMaestro: dPC.contenido.grid,
          da_headgridMaestro: dPC.contenido.headgrid,
        });
      }
    });
  }, [recargaMaestros]);

  useEffect(() => {
    // const productoTerminadoAPI = _api_.f_estructuraObtenerProductosTerminadosPP({
    //   parametros: { codProducto: registro?.codigo },
    //   timeout: 5000,
    // });
    // productoTerminadoAPI.respuesta.then((dPC) => {
    //   _f_.asignar(ecv_u, dPC, true, origenComponente);
    //   console.log(dPC);
    //   if (!dPC.error) {
    //     _f_.asignar(ev_u, {
    //       da_gridProductoTerminado: dPC.contenido.grid,
    //       da_headgridProductoTerminado: dPC.contenido.headgrid,
    //     });
    //   }
    // });
  }, [recargaPP]);

  return (
    <div className={"MDetalleInferiorEtapasPTCSS-contenido"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, { modal_mostrar: false, agregarEtapaModal: false, relacionarPT_mostrar: false });
          }}>
          {/* {v_c.agregarEtapaModal && (
            <MAgregarEditarProductoTerminado
              origenComponente={origenComponente}
              datosComplementarios={registro}
              registro={{}}
              fCerrarComponente={() => {
                _f_.asignar(ev_c, { modal_mostrar: false, agregarEtapaModal: false });
              }}
              fActualizarTablaTotal={(actualizar) => {
                if (actualizar) {
                  erecargaMaestros((prev) => !prev);
                }
              }}
            />
          )} */}
          <MAgregarEditarEmpaquetadorEtapaPT
            origenComponente={origenComponente}
            datosComplementarios={registro}
            registro={{
              codigoEtapa: 0,
            }}
            fCerrarComponente={() => {
              _f_.asignar(ev_c, { modal_mostrar: false, relacionarPT_mostrar: false });
            }}
            fActualizarTablaTotal={(actualizar) => {
              if (actualizar) {
                erecargaMaestros((prev) => !prev);
              }
            }}
          />
        </ModalInformacion>
      )}
      <div className={"MDetalleInferiorEtapasPTCSS-tablas"}>
        <div className="MDetalleInferiorEtapasPTCSS-TablaMaestros">
          <_tabla_.Tabla
            origenComponente={origenComponente}
            modoVista={"modo4"}
            camposCodigosSeleccion={["codigo"]}
            campoCodigoCategoria={"categoria"}
            campoCodigoRegistrosPorCategoria={"registros"}
            campoCodigoDespliegaDetalleRegistro={"codigo"}
            permiteDespliegueInferiorPorRegistro={false}
            colorCabeceraCategoria={"var(--color_amarillo_1)"}
            colorFuenteCabeceraCategoria={"black"}
            cabecera={v_u.da_headgridMaestro}
            registros={v_u.da_gridMaestro}
            zIndexTabla="2"
            datosComplementarios={registro}
            mapaDeComponentes={{
              // MEliminarProductoTerminado,
              MEliminarEmpaquetadorEtapaPT,
              MAgregarEditarEmpaquetadorEtapaPT,
            }}
            fNotificarActualizacionDeTabla={(actualizar) => {
              if (actualizar) {
                erecargaMaestros((prev) => !prev);
              }
            }}
          />
        </div>
      </div>
      <div className={"MDetalleInferiorEtapasPTCSS-opciones"}>
        <_btn_.Boton
          texto={`Agregar Empaquetador`}
          tipo="btn-2"
          estilos={{
            anchoB2: "15rem",
            altoB2: "2rem",
            color: "var(--color_amarillo_1)",
            fuente: "1rem",
            colorFuenteB2: "black",
          }}
          onClick={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_titulo: "Agregar Empaquetador a la Etapa",
              agregarEtapaModal: true,
              modal_estilos: { anchoMI: "30rem", altoMI: "initial" },
            });
          }}
        />
      </div>
    </div>
  );
}
export default MDetalleInferiorEtapasPT;
